import { render, staticRenderFns } from "./BusinessMapping.vue?vue&type=template&id=41008f96&scoped=true"
import script from "./BusinessMapping.vue?vue&type=script&lang=js"
export * from "./BusinessMapping.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41008f96",
  null
  
)

export default component.exports